import styled from 'styled-components';

import { media } from '@bitcoin-portal/verse-web-components/dist/themes/breakpoints';
import { colors } from '@bitcoin-portal/verse-web-components/dist/themes/colors';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  box-sizing: border-box;

  max-width: 100vw;
  width: 100%;
  overflow: visible;
`;

export const TitleWrapper = styled.div`
  padding: 0 16px;

  & > h3 {
    text-transform: uppercase;
  }

  & > div {
    font-size: 14px;
    color: ${colors.shade80};

    ${media.sm`
      font-size: 16px;
    `}
  }
`;

export const ContentWrapper = styled.div`
  box-sizing: border-box;
  margin: 16px;

  ${media.sm`
    width: 440px;
  `}
`;
